import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-24 md:py-32" data-testid="page-not-found">
      <p className="text-xs uppercase tracking-[0.3em] text-[#BA6D52]">Seite nicht gefunden</p>
      <h1 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-6 leading-[1.1]">
        Hier ist die Küche leer.
      </h1>
      <p className="text-[#757067] font-light text-base md:text-lg leading-relaxed mt-6 max-w-xl">
        Diese Adresse gibt es nicht — vielleicht ein Tippfehler oder ein alter Link.
        Falls Sie einen persönlichen Link aus einer E-Mail geöffnet haben und diese Seite
        sehen, melden Sie sich gerne kurz, dann schicke ich Ihnen einen neuen.
      </p>
      <div className="mt-10 flex flex-wrap gap-3">
        <Link to="/" data-testid="notfound-home"
          className="inline-flex items-center gap-3 bg-[#BA6D52] text-white hover:bg-[#9E5841] px-8 py-4 text-xs uppercase tracking-[0.2em] transition-colors">
          Zur Startseite <ArrowRight size={16} />
        </Link>
        <Link to="/kontakt" data-testid="notfound-kontakt"
          className="inline-flex items-center gap-3 border border-[#E3DECE] text-[#2C2A26] hover:border-[#BA6D52] hover:text-[#BA6D52] px-8 py-4 text-xs uppercase tracking-[0.2em] transition-colors">
          Kontakt
        </Link>
      </div>
      <p className="text-sm text-[#757067] mt-10">
        Telefon: <a href="tel:+4915127282560" className="text-[#BA6D52] hover:underline">+49 151 27282560</a>
      </p>
    </div>
  );
}
